export class ExceptionRuleRepo {
    private httpService: IHttpService;
    constructor(instance: IHttpService) {
        this.httpService = instance;
    }

    async getExceptionRules(ids?: number[] | number): Promise<any[]> {
        const params = ids ? { exception_rule_id__in: Array.isArray(ids) ? ids.join(',') : ids } : {};
        try {
            const response = await this.httpService.get<TKResponses<any>>('/exception_rules', { params: params });
            return response.data.sort((a, b) => ((a as any).name ?? '').localeCompare((b as any).name ?? ''));
        } catch (error) {
            console.error('Error fetching exception rules:', error);
            throw error;
        }
    }

    async createExceptionRule(data: any): Promise<any> {
        try {
            const response = await this.httpService.post<TKResponse<any>, any>('/exception_rules', { data });
            return response.data;
        } catch (error) {
            console.error('Error creating exception rule:', error);
            throw error;
        }
    }

    async updateExceptionRule(id: number, data: any): Promise<any> {
        try {
            const response = await this.httpService.patch<TKResponse<any>, any>(`/exception_rules/${id}`, { data });
            return response.data;
        } catch (error) {
            console.error('Error updating exception rule:', error);
            throw error;
        }
    }

    async deleteExceptionRule(id: number): Promise<any> {
        try {
            // TODO Revisar como funciona el endpoint de eliminacion
            // const body = {
            //     exception_rule_ids: selectedRow
            // }
            // return await instance.delete(`/exception_rules`, { data: body })
            const response = await this.httpService.delete<TKResponse<any>>(`/exception_rules/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting exception rule:', error);
            throw error;
        }
    }
}
